/* unplugin-vue-components disabled */import script from "./HandicapTrendView.vue?vue&type=script&setup=true&lang=js"
export * from "./HandicapTrendView.vue?vue&type=script&setup=true&lang=js"

import "./HandicapTrendView.vue?vue&type=style&index=0&id=ea89b370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea89b370"]])

export default __exports__